<template>
  <app-logged>
    <v-flex xs12>
      <validation-observer
        ref="observer"
        v-slot="{ invalid }"
        tag="form"
      >
        <v-form>
          <app-widget
            actions
            class-widget="md6 offset-md3 sm8 offset-sm2 xs12"
          >
            <div slot="widget-content">
              <div class="mb-4">
                <app-button
                  v-if="$route.meta.manual"
                  block
                  outlined
                  @click.native.prevent="goToManual"
                >
                  <v-icon class="mr-2">
                    add
                  </v-icon>
                  inserir laudo manualmente
                </app-button>
              </div>
              <v-divider class="mb-4" />
              <AppFormHeader
                title="Informe a indústria responsável"
                icon="apartment"
              />
              <validation-provider
                name="industria"
                rules="required"
                v-slot="{ errors }"
              >
                <v-autocomplete
                  label="Industria"
                  :items="industrias"
                  clearable
                  v-model="industria"
                  :return-object="false"
                  item-text="nome_fantasia"
                  item-value="id"
                  :error-messages="errors[0]"
                />
              </validation-provider>
              <validation-provider
                name="arquivo excel"
                rules="required"
                v-slot="{ errors }"
              >
                <v-file-input
                  accept=".xlsx"
                  label="Selecione um arquivo .xlsx"
                  outlined
                  v-model="file"
                />
              </validation-provider>
              <div class="caption grey--text text-left">
                <strong>Atenção</strong><br>
                <ul>
                  <li>Verifique a integridade do arquivo a ser importado;</li>
                  <li>Confirme que todos os clientes, industrias e vínculos estão cadastrados;</li>
                  <li>O número de CPF do cliente deve estar formatado (ex: 000.000.000-00);</li>
                  <li>O nome da planilha deve ser {{ nomePlanilha }};</li>
                  <li>A primeira linha da planilha deve ser o cabeçalho da tabela;</li>
                </ul>
              </div>
            </div>
            <div slot="widget-actions">
              <v-spacer />
              <app-button
                @click.native.prevent="carregar"
                :disable="invalid"
              >
                Importar
              </app-button>
            </div>
          </app-widget>
        </v-form>
      </validation-observer>
    </v-flex>
  </app-logged>
</template>
<script>
import AppLogged from '@/components/layouts/AppLogged'
import { mapGetters, mapActions } from 'vuex'
import { nomePlanilha } from '../../../stores/xlsx/laudo'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import AppWidget from '@/components/AppWidget'
import AppFormHeader from '@/components/AppFormHeader'
import AppButton from '@/components/AppButton'
export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    AppFormHeader,
    AppLogged,
    AppWidget,
    AppButton
  },
  data () {
    return {
      file: null,
      industria: null,
      nomePlanilha
    }
  },
  computed: {
    ...mapGetters(['visita', 'industrias'])
  },
  methods: {
    ...mapActions(['carregarMultiplosLaudos']),
    goToManual () {
      this.$router.push({
        name: 'laudos-create'
      })
    },
    async carregar () {
      if (
        confirm(
          'Certifique-se de que está carregando o arquivo correto. Toque OK para confirmar.'
        )
      ) {
        await this.carregarMultiplosLaudos({
          file: this.file,
          industria: this.industria
        })
      }
    }
  }
}
</script>
